{
  "GENERAL": {
    "CLOSE": "Loka",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Leit",
      "EMPTY_STATE": "Engar niðurstöður fundust"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Að minnsta kosti {count} krafist"
  }
}
